import { Timestamp } from "firebase/firestore";

export interface CompetitionResult {
  id: string;
  competitionId: string;
  name: string;
  fullName: string;
  location: string;
  date: string;
  categories: CategoryResult[];
  displaySettings?: CompetitionDisplaySettings;
  updatedAt: Timestamp;
}

export interface CategoryResult {
  categoryId: string;
  index: number;
  name: string;
  fullName: string;
  day?: number;
  publicationScopes?: {
    hasPublishedRounds?: boolean;
    categoryFinal?: boolean;
    competitionFinal?: boolean;
  };
  rounds: RoundResult[];
  finalResults?: FinalResults;
}

export interface RoundResult {
  roundId: string;
  stageCode?: string;
  type: RoundType;
  name: string;
  judges?: JudgeResult[];
  results: Result[];
}

export interface Result {
  place?: number;
  promotion?: boolean;
  presentation: PresentationResult;
  presentations?: PresentationResult[];
}

export interface PresentationResult {
  id: string;
  name: string;
}

export interface JudgeResult {
  id: string;
  firstName: string;
  lastName: string;
  index?: string;
}

export interface FinalResultsRound {
  roundId: string;
  stageCode?: string;
  name: string;
  type: RoundType;
  judges: string[];
}

export interface FinalResultsRow {
  place: number;
  presentationId: string;
  name: string;
  title?: string;
  rounds: string[];
  roundResults?: {
    roundId: string;
    value: string;
  }[];
}

export type FinalPlaceRankingModePublished = "standard" | "dense";

export interface FinalResults {
  judges: JudgeResult[];
  rounds: FinalResultsRound[];
  rows: FinalResultsRow[];
  /** Ustalony przy publikacji — numeracja w `rows` jest z tym zgodna. */
  finalPlaceRankingMode?: FinalPlaceRankingModePublished;
  publicationScopes?: {
    category?: boolean;
    competition?: boolean;
  };
  publishedAt: Timestamp;
}

export interface CompetitionDisplaySettings {
  showCompetitionInResultsApp?: boolean;
  hideRoundResultsWhenFinalResultsPublished?: boolean;
}

export enum RoundType {
  ELIMINATIONS = 0,
  FINAL = 1,
}

export type CompetitionWithId = CompetitionResult;
